import React, { Component, Fragment } from 'react';
import { Layout, Breadcrumb, Table, Button, Row, Col, List } from 'antd';
import * as mobx from 'mobx';
import NumberFormat from 'react-number-format';
import styles from './styles.module.css';
import { inject, observer } from "mobx-react";
const { Content } = Layout;

class Fund extends Component {

  constructor() {
    super();
    this.state = {
      user: null,
      contracts: []
    }
  }

  loadContractForUser() {
    this.props.main.fetchFundStatus().then((data) => {
      this.setState({
        contracts: data || []
      })
    });
  }

  componentWillReceiveProps(new_props) {
    if(new_props.main.auth_user !== this.state.user) {
      this.setState({ user: new_props.main.auth_user }, () => {
        if(new_props.main.auth_user !== null) {
          this.loadContractForUser();
        }
      });
    }
  }

  getPayin(item) {
    switch(item.status) {
      case 'payment':
        return (
          <Fragment>
            <h3>Payment information</h3>
            <ul>
              <li>Amount: {item.payin_amount} {item.payin_currency}</li>
              <li>Deposit address: {item.payin_address}</li>
            </ul>
          </Fragment>
        )
      break;
      case 'processing':
        return (
          <Fragment>
            <h3>Funds Received</h3>
            <div>Your funds were received and awaiting market entry</div>
          </Fragment>
        )
      break;
      case 'active':
        return (
          <Fragment>
            <h3>Funds Active</h3>
            <div>Your funds have been entered into market positions</div>
          </Fragment>
        )
      break;
      default:
        return (
          <Fragment>
            <h3>Risk Warning</h3>
            <div>Cryptocurrency market trading is highly speculative and carries a high level of risk. It is possible to lose all your capital. Seek independent advice if necessary before entering this contract.</div>
          </Fragment>
        )
    }
  }

  acceptItem = (id) => {
    this.props.main.signFundContract(id).then((data) => {
      this.setState({
        contracts: data || []
      })
    });
  }

  getContractsListItem = (item) => {
    let desc = (
      <ul className={styles.meta}>
        <li>{"Created: " + item.created}</li>
        <li className={styles.status}>{"Status: "+ item.status}</li>
      </ul>
    );
    return (
      <List.Item actions={item.signed ? [] : [<Button type="primary" onClick={() => {this.acceptItem(item._id)}}>Accept Terms</Button>]}>
        <div className={styles.list_body}>
          <h3>Contract ID {item._id}</h3>
          {desc}
          <h3>Contract Terms</h3>
          <ul className={styles.list}>
            <li>Investment term: {item.investment_term} months</li>
            <li>Yearly management fee (% of managed assets): {item.assets_fee * 100}%</li>
            <li>Yearly success fee (% from profit): {item.profit_fee * 100}%</li>
            <li>Transaction fees: paid by investor</li>
            <li>Strategy: {item.strategy}</li>
            <li>Initial investment: {item.investment_amount} {item.investment_currency}</li>
          </ul>
          {this.getPayin(item)}
        </div>
      </List.Item>
    );
  }

  getContractsList() {
    return (
      <Fragment>
        <h2>Crypto Fund Contracts</h2>
        <List
          size="large"
          bordered
          dataSource={this.state.contracts}
          renderItem={this.getContractsListItem}
        />
      </Fragment>
    )
  }

  renderFundPage() {
    if(this.props.main.authenticated === false) {
      return (
        <Fragment>
          <h2>Crypto Fund Contracts</h2>
          <div>Please login to continue to this page</div>
          <Button type="primary" icon="login" onClick={()=>{ this.props.main.login(); }}>Login</Button>
        </Fragment>
      );
    } else {
      if(this.state.contracts.length === 0) {
        return (
          <Fragment>
            <h2>Crypto Fund Contracts</h2>
            <div>You have no fund contracts at the moment</div>
          </Fragment>
        );
      } else {
        return this.getContractsList();
      }
    }
  }

  render() {
    return(
      <Content>
        <Breadcrumb style={{
            margin: '1em 2em'
          }}>
          <Breadcrumb.Item>Services</Breadcrumb.Item>
          <Breadcrumb.Item>Crypto Fund</Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.main}>
          <Row gutter={32}>
            <Col md={{span: 24}} lg={{span: 12, offset: 6}}>
              {this.renderFundPage()}
            </Col>
          </Row>
        </div>
      </Content>);
  }
}

export default inject("main")(observer(Fund));



// WEBPACK FOOTER //
// ./src/containers/Fund/Fund.js